import { setFlashMessage } from 'app/features/flashMessage/actions';
import { isDeviceActivated } from 'app/features/deviceActivation/selectors';

const deviceActivation = () => (dispatch, getState) => {
  if (isDeviceActivated(getState())) {
    dispatch(
      setFlashMessage({
        messageId: 'device_activation_flash_message',
        statusType: 'success',
      }),
    );
  }
};

export { deviceActivation };
